export const baseConfig = {
  headers: {
    'Content-Type': 'application/json',
    // 'Accept-Encoding': 'gzip, deflate', - give warnings sending leads
  },
};

export const apiConfig = {
  it_casa: {
    mycasa: {
      baseURL: {
        local: 'https://api-mycasa.dev.casa.it',
        dev: 'http://api-mycasa.internal.casa.it',
        stg: 'http://api-mycasa.internal.casa.it',
        prod: 'http://api-mycasa.internal.casa.it',
      },
      detail: {
        url: '/api/v1/Listings',
        headers: {},
        validation: {
          status: 'SUCCESS',
          code: 200,
        },
      },
    },
    esapi: {
      baseURL: {
        local: 'https://api-search.dev.casa.it',
        dev: 'http://api-search.internal.casa.it',
        stg: 'http://api-search.internal.casa.it',
        prod: 'http://api-search.internal.casa.it',
      },
      listing: {
        url: '/listings/v2/search/',
        headers: {},
        validation: {
          status: 'SUCCESS',
          code: 200,
        },
      },
      detail: {
        url: '/listings/v2/',
        params: {
          site: 'it_casa',
          output: 'v2',
          related: 'true',
          expands: 'phones,mg,v2.type',
          include_offline: 'true',
        },
        keepAlive: true,
        timeout: 10000,
        validation: {
          status: 'SUCCESS',
          code: 200,
        },
      },
      seofooter: {
        url: '/listings/v2/hp_footer',
        params: {
          site: 'it_casa',
        },
        keepAlive: true,
        validation: {
          status: 'SUCCESS',
          message: 'success',
          code: 200,
        },
      },
      hubpage: {
        url: '/listings/v2/hub/',
        params: {
          site: 'it_casa',
        },
        keepAlive: true,
        validation: {
          status: 'SUCCESS',
          message: 'success',
          code: 200,
        },
      },
      poiNearby: {
        url: '/v2/pois/search',
        params: {
          site: 'it_casa',
        },
        headers: {},
        keepAlive: true,
        validation: {
          status: 'SUCCESS',
          code: 200,
        },
      },
    },
    account: {
      baseURL: {
        local: 'https://www.dev.casa.it',
        // local: 'http://local.casa.it:3002',
        dev: 'https://www.dev.casa.it',
        stg: 'https://www.dev.casa.it',
        prod: 'https://www.casa.it',
      },
      login: {
        url: '/client-account/api/v1/social',
        headers: {},
        validation: {
          succeed: true,
          statusCode: 200,
        },
      },
      getJwt: {
        url: '/client-account/api/v1/user/getjwt',
        headers: {},
        validation: {
          response: {
            succeed: true,
          },
        },
      },
      setConsent: {
        url: '/client-account/api/v1/user/setconsent',
        headers: {},
        validation: {
          response: {
            succeed: true,
          },
        },
      },
    },
    leads: {
      baseURL: {
        local: 'https://api-leads.dev.casa.it',
        dev: 'http://api-leads.internal.casa.it',
        stg: 'http://api-leads.internal.casa.it',
        prod: 'http://api-leads.internal.casa.it',
      },
      specific: {
        url: '/v1/leads/specific',
        headers: {},
        validation: {
          code: 201,
          status: 'created',
        },
      },
      generic: {
        url: '/v1/leads/generic?source=pdp',
        headers: {},
        validation: {
          code: 201,
          status: 'created',
        },
      },
      share: {
        url: '/v1/leads/share',
        headers: {},
        validation: {
          code: 201,
          status: 'created',
        },
      },
    },
    idealista: {
      baseURL: {
        local: 'https://www.idealista.bz',
        dev: 'https://www.idealista.bz',
        stg: 'https://www.idealista.bz',
        prod: 'https://www.idealista.it',
      },
      casaBaseURL: {
        local: 'http://local.casa.it:3000',
        dev: 'https://www.dev.casa.it',
        stg: 'https://www.stg.casa.it',
        prod: 'https://www.casa.it',
      },
      mortgage: {
        url: '/mutui/casait?info=',
        securityKey: 'E259CF1C8F35CF3106681F1E732C2AFD',
        algorithm: 'aes-256-ecb',
      },
    },
  },
};
